// 公共方法
import Vue from 'vue'

var common = function () {
    return {
        // 处理element select组件 在edge下 操作select部分电脑会重新刷新页面
        selectVisibleChange: function (isVisible, className) {
            const isEdge = navigator.userAgent.indexOf("Edge") > -1;
            if(isEdge && !isVisible) {
                document.querySelectorAll('body > .el-select-dropdown.el-popper.'+className).forEach((it) => {
                    it.remove();
                })
            }
        }
    }
}();

if (typeof(Vue) == "function") Vue.prototype.common = common;